module.exports = __webpack_public_path__ + "static/hybrid_shocker-1d6dc8184f910f599bf7ac504fee1cd8.png";